import { create } from 'zustand'

// Поиск живёт в шапке приложения, а применяет его текущий раздел: строка
// одна на всё приложение, каждая страница читает её и фильтрует своё.
// При переходе между разделами запрос сбрасывается - искать «остатками»
// предыдущего раздела почти всегда не то, чего ждёт оператор.
interface PageSearchState {
    query: string
    open: boolean
    setQuery: (query: string) => void
    setOpen: (open: boolean) => void
    reset: () => void
}

export const usePageSearchStore = create<PageSearchState>()((set) => ({
    query: '',
    open: false,
    setQuery: (query) => set({ query }),
    setOpen: (open) => set((state) => ({ open, query: open ? state.query : '' })),
    reset: () => set({ query: '', open: false }),
}))
